import React from "react";
import Footer from "./footer";

const Terms = () => {
  return (
    <React.Fragment>
      <div className="card rounded-3 shadow mx-lg-5 mx-md-3 mx-sm-1 my-4 p-xxl-5 py-3 text-center flex-fill">
        <nav>
          <div className="nav nav-tabs mb-3" id="nav-tab" role="tablist">
            <button
              className="nav-link active"
              id="nav-terms-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-terms"
              type="button"
              role="tab"
              aria-controls="nav-terms"
              aria-selected="true"
            >
              TERMS AND CONDITIONS
            </button>
            <button
              className="nav-link"
              id="nav-privacy-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-privacy"
              type="button"
              role="tab"
              aria-controls="nav-privacy"
              aria-selected="false"
              tabindex="-1"
            >
              PRIVACY POLICY
            </button>
            <button
              className="nav-link"
              id="nav-faqs-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-faqs"
              type="button"
              role="tab"
              aria-controls="nav-faqs"
              aria-selected="false"
              tabindex="-1"
            >
              FAQS
            </button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane fade active show"
            id="nav-terms"
            role="tabpanel"
            aria-labelledby="nav-terms-tab"
          >
            <div className="accordion" id="accordionExample">
              <div className="row row-cols-1 row-cols-md-2 mx-lg-5 mx-md-3 mx-sm-1">
                <div className="col mb-3">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Accordion Item #1
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <strong>
                          This is the first item's accordion body.
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Accordion Item #2
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <strong>
                          This is the second item's accordion body.
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Accordion Item #3
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <strong>
                          This is the third item's accordion body.
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col mb-3">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Accordion Item #4
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <strong>This is the four item's accordion body.</strong>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        Accordion Item #5
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <strong>This is the five item's accordion body.</strong>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        Accordion Item #6
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <strong>This is the six item's accordion body.</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-privacy"
            role="tabpanel"
            aria-labelledby="nav-privacy-tab"
          >
            <p>
              <strong>privacy tab's</strong>
            </p>
          </div>
          <div
            className="tab-pane fade"
            id="nav-faqs"
            role="tabpanel"
            aria-labelledby="nav-faqs-tab"
          >
            <p>
              <strong>FAQS tab's</strong>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default Terms;
